import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import { bool } from "prop-types";
import React from "react";
import ResponsiveHeader from "pages/_components/header";
import GridTable from "pages/_components/GridTable/GridTable";
import * as configUtils from "util/config";
import I18n from "pages/_components/I18n";
import CustomText from "pages/_components/CustomText/CustomText";

const ComissionList = ({ isDesktop }) => {
    const comexComissions = configUtils.getArray("comex.comissions");

    return (
        <>
            <Notification scopeToShow="comissionList" />
            <ResponsiveHeader id="comex.comissions.title" backLinkTo="/comex/transfer" />

            <MainContainer>
                <GridTable className="comissions-table">
                    <GridTable.Header className="light">
                        <GridTable.Container className="comissions-item" columns={12} columnsTemplate="fixed">
                            <GridTable.Data
                                className="comissions-data"
                                columnStart={1}
                                columnWidth={isDesktop ? 10 : 9}>
                                <CustomText text="comex.comissions.concept.title" textType="I18N" keepSpaceIfNoText />
                            </GridTable.Data>
                            <GridTable.Data
                                className="comissions-data"
                                columnStart={isDesktop ? 11 : 10}
                                columnWidth={isDesktop ? 2 : 3}>
                                <CustomText text="comex.comissions.price.title" textType="I18N" keepSpaceIfNoText />
                            </GridTable.Data>
                        </GridTable.Container>
                    </GridTable.Header>

                    {comexComissions.map((comissions) => (
                        <GridTable.Container className="comissions-item" columns={12} columnsTemplate="fixed">
                            <>
                                <GridTable.Data
                                    className="comissions-data"
                                    columnStart={1}
                                    columnWidth={isDesktop ? 10 : 9}
                                    key={comissions}>
                                    <CustomText text={`comex.comissions.${comissions}.detail.label`} textType="I18N" />
                                </GridTable.Data>
                                <GridTable.Data
                                    className="comissions-data comissions-data-price"
                                    columnStart={isDesktop ? 11 : 10}
                                    columnWidth={isDesktop ? 2 : 3}
                                    key={comissions}>
                                    <CustomText text={`comex.comissions.${comissions}.price`} textType="I18N" />
                                </GridTable.Data>
                            </>
                        </GridTable.Container>
                    ))}
                </GridTable>
                <I18n id="comex.comissions.reference" componentProps={{ className: "reference-comissions" }} />
                <br />
            </MainContainer>
        </>
    );
};

export default ComissionList;

ComissionList.propTypes = {
    isDesktop: bool.isRequired,
};
